/* eslint-disable no-use-before-define */
import React, {useEffect} from 'react';
import {useLocation, matchPath, Link as RouterLink} from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {Box, Divider, Drawer, Hidden, List, ListSubheader, makeStyles} from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import {
    Calendar as CalendarIcon,
    Folder as FolderIcon,
    Edit as EditIcon,
    DollarSign as DollarSignIcon,
    PieChart as PieChartIcon,
    Share2 as ShareIcon,
    Users as UsersIcon,
    Inbox as InboxIcon,
} from 'react-feather';
import Logo from 'src/components/Logo';
import NavItem from './NavItem';

const sections = [
    {
        // subheader: 'Sidebar',
        items: [
            {
                title: 'Dashboard',
                icon: PieChartIcon,
                href: '/dashboard',
            },
            {
                title: 'Cases',
                icon: InboxIcon,
                href: '/cases',
            },
            {
                title: 'Clients',
                icon: UsersIcon,
                href: '/clients',
            },
            {
                title: 'Courts',
                icon: FolderIcon,
                href: '/courts',
            },
            {
                title: 'Defense Attorneys',
                icon: UsersIcon,
                href: '/defense-attorneys',
            },
            {
                title: 'Third Parties',
                icon: ShareIcon,
                href: '/third-parties',
            },
            {
                title: 'Checks',
                icon: ReceiptIcon,
                href: '/checks',
            },
            {
                title: 'Disbursements',
                icon: ReceiptIcon,
                href: '/disbursements',
            },
            {
                title: 'Remittances',
                icon: ReceiptIcon,
                href: '/remittances',
            },
            {
                title: 'Invoices',
                icon: DollarSignIcon,
                href: '/invoices',
            },
            // {
            //     title: 'Check Reconciliation',
            //     icon: FolderIcon,
            //     href: '/check-reconciliation',
            // },
            {
                title: 'Attach Event Document',
                icon: CalendarIcon,
                href: '/attach-event-document',
            },
            {
                title: 'Batch Payment',
                icon: DollarSignIcon,
                href: '/batch-payment',
            },
            {
                title: 'Diary Review',
                icon: EditIcon,
                href: '/diary-review',
            },
        ],
    },
];

function renderNavItems({items, pathname, depth = 0}) {
    return (
        <List disablePadding>
            {items.reduce((acc, item) => reduceChildRoutes({acc, item, pathname, depth}), [])}
        </List>
    );
}

function reduceChildRoutes({acc, pathname, item, depth}) {
    const key = item.title + depth;

    if (item.items) {
        const open = matchPath(pathname, {
            path: item.href,
            exact: false,
        });

        acc.push(
            <NavItem
                depth={depth}
                icon={item.icon}
                info={item.info}
                key={key}
                open={Boolean(open)}
                title={item.title}
            >
                {renderNavItems({
                    depth: depth + 1,
                    pathname,
                    items: item.items,
                })}
            </NavItem>
        );
    } else {
        acc.push(
            <NavItem
                depth={depth}
                href={item.href}
                icon={item.icon}
                info={item.info}
                key={key}
                title={item.title}
            />
        );
    }

    return acc;
}

const useStyles = makeStyles(() => ({
    mobileDrawer: {
        width: 256,
    },
    desktopDrawer: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)',
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64,
    },
}));

const NavBar = ({onMobileClose, openMobile}) => {
    const classes = useStyles();
    const location = useLocation();

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const content = (
        <Box height="100%" display="flex" flexDirection="column">
            <PerfectScrollbar options={{suppressScrollX: true}}>
                <Hidden lgUp>
                    <Box p={2} display="flex" justifyContent="center">
                        <RouterLink to="/dashboard">
                            <Logo />
                        </RouterLink>
                    </Box>
                </Hidden>
                <Divider />
                <Box p={2}>
                    {sections.map((section, index) => (
                        <List
                            key={`${section.subheader}-${index}`}
                            subheader={
                                <ListSubheader disableGutters disableSticky>
                                    {section.subheader}
                                </ListSubheader>
                            }
                        >
                            {renderNavItems({
                                items: section.items,
                                pathname: location.pathname,
                            })}
                        </List>
                    ))}
                </Box>
            </PerfectScrollbar>
        </Box>
    );

    return (
        <>
            <Hidden lgUp>
                <Drawer
                    anchor="left"
                    classes={{paper: classes.mobileDrawer}}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant="temporary"
                >
                    {content}
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer
                    anchor="left"
                    classes={{paper: classes.desktopDrawer}}
                    open
                    variant="persistent"
                >
                    {content}
                </Drawer>
            </Hidden>
        </>
    );
};

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool,
};

export default NavBar;
